import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import '../../../assets/guestportal.css'
import { FaTimes, FaBars } from 'react-icons/fa';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/product', label: 'Product' },
    { path: '/use-cases', label: 'Use Cases' },
    { path: '/integrations', label: 'Integrations' },
    { path: '/faq', label: 'FAQ' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/contact', label: 'Contact Us' },
  ];

  return (
    <header className="shadow-sm header-wrapper guest-header">
      <nav className="navbar navbar-expand-lg bg-white p-0">
        <div className="container-fluid d-flex justify-content-between align-items-center header-container">
          {/* Left Section - Logo */}
          <div className="header-logo-section">
            <NavLink to="/" className="navbar-brand">
              <img src="/lovable-uploads/58b9d0fd-9a56-4037-a276-b9887eff6b00.png" alt="Logo" className="header-logo" />
            </NavLink>
          </div>

          {/* Center Section - Navigation Menu (Desktop) */}
          <div className="header-nav-section d-none d-lg-flex">
            <ul className="navbar-nav mb-2 mb-lg-0 d-flex flex-row">
              {navLinks.map((link, index) => (
                <li className="nav-item" key={index}>
                  <NavLink to={link.path} className="nav-link p-o" onClick={() => setMenuOpen(false)}>{link.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Section - Auth Buttons (Desktop) */}
          <div className="header-auth-section d-none d-lg-flex">
            <div className="auth-buttons d-flex">
              <NavLink to="https://app.docusafe.ai/login" target="_blank" className="login-btn-header me-2 text-decoration-none rounded text-dark">Login</NavLink>
              <NavLink to="https://app.docusafe.ai/sign-up" target="_blank" className="signup-btn text-decoration-none rounded">Sign Up</NavLink>
            </div>
          </div>

          {/* Hamburger Icon (Mobile) */}
          <button
            className="mobile-menu-toggle d-lg-none d-flex"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? (
              <FaTimes size={28} color="#F0EFE7" />
            ) : (
              <FaBars size={28} color="#232D7E" />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="mobile-menu-overlay">
          <ul className="mobile-nav-links">
            {navLinks.map((link, index) => (
              <li key={index}>
                <NavLink to={link.path} className="nav-link" onClick={() => setMenuOpen(false)}>{link.label}</NavLink>
              </li>
            ))}
          </ul>
          <div className="mobile-auth-buttons">
            <NavLink to="https://app.docusafe.ai/login" className="login-btn mb-2 text-decoration-none rounded tesxt-dark" onClick={() => setMenuOpen(false)}>Login</NavLink>
            <NavLink to="https://app.docusafe.ai/sign-up" className="signup-btn text-decoration-none rounded" onClick={() => setMenuOpen(false)}>Sign Up</NavLink>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
